import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './main/login/login.component';
import { MyRecordingsComponent } from './main/myRecordings/myRecordings.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'Login', component: LoginComponent },
  { path: 'MyRecordings', component: MyRecordingsComponent },
  {
    path: '**',
    redirectTo: 'Login',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, { useHash: true }),
  ],
  declarations: [],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts